<template>
    <div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <h1 class="text-2xl font-semibold text-gray-900">
                {{ $t('global.404.title') }}
            </h1>
        </div>

        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mt-4">
            <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                    {{ $t('global.404.description') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {};
</script>
